module.exports = __webpack_public_path__ + "static/revival4-7fa44ea153acbef491504c0cd96c9c45.jpg";